import script from "./DcraEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./DcraEditor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__